module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Weapons of Our Warfare")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter#front-1",
      "id": "ft-1"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#chap-01",
      "id": "ch-01"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#chap-02",
      "id": "ch-02"
    }
  }, [_vm._v("1—The Power of His Might")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#chap-03",
      "id": "ch-03"
    }
  }, [_vm._v("2—They Know Not What They Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#chap-04",
      "id": "ch-04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3—The Whole Armor of God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#chap-05",
      "id": "ch-05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4—Strength Made Perfect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#chap-06",
      "id": "ch-06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5—Fighting the Right Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#chap-07",
      "id": "ch-07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6—The Dual Purpose of the Armor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#chap-08",
      "id": "ch-08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7—Belt of Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#chap-09",
      "id": "ch-09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8—Belt of Truth: Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#chap-10",
      "id": "ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9—Breastplate of Righteousness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#chap-11",
      "id": "ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10—Breastplate of Righteousness: Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#chap-12",
      "id": "ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11—Shoes of the Gospel of Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#chap-13",
      "id": "ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12—Shoes of the Gospel of Peace: Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#chap-14",
      "id": "ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13—Shield of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#chap-15",
      "id": "ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14—Shield of Faith: Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#chap-16",
      "id": "ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15—Helmet of Salvation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#chap-17",
      "id": "ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16—Helmet of Salvation: Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#chap-18",
      "id": "ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17—Sword of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#chap-19",
      "id": "ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18—Sword of the Spirit: Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#chap-20",
      "id": "ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19—Sword of the Spirit: Part 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#chap-21",
      "id": "ch-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20—Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#chap-22",
      "id": "ch-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21—Prayer: Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter#back-01",
      "id": "bk-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography#bibl-1",
      "id": "bib-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6ec521","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contenttoc.vue
// module id = 66
// module chunks = 0